import { useState } from "react";

// Chakra imports
import {
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
// Assets
import { MdBuild, MdEditNote, MdOutlineArchive, MdOutlineMoreHoriz, MdOutlineUnarchive } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useSite } from "hooks/useSite";

interface MenuComponentProps {
  siterow: SiteType[];
  openmodal: () => void;
  setselectedsite: (data: SiteType[]) => void | null;
  setData: (data: SiteType[]) => void;
}

export default function ListMenuSite(props: MenuComponentProps): JSX.Element {
  const textColor = useColorModeValue("secondaryGray.500", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue("14px 17px 40px 4px rgba(112, 144, 176, 0.08)", "unset");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue({ bg: "secondaryGray.400" }, { bg: "whiteAlpha.50" });
  const bgFocus = useColorModeValue({ bg: "secondaryGray.300" }, { bg: "whiteAlpha.100" });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { getSites, setSiteActif } = useSite();
  const [busy, setBusy] = useState(false);
  const site = props.siterow[0];
  const history = useHistory();

  function handleUpdate() {
    props.setselectedsite(props.siterow);
    props.openmodal();
  }

  async function handleArchive() {
    if (busy) {
      return;
    }
    setBusy(true);
    try {
      await setSiteActif(site.id, !site.actif);
      props.setData(await getSites());
    } catch (error) {
      console.error(error);
    } finally {
      setBusy(false);
    }
  }

  const item = { transition: "0.2s linear", color: textColor, _hover: textHover, p: "0px", borderRadius: "8px", _active: { bg: "transparent" }, _focus: { bg: "transparent" }, mb: "10px" };
  return (
    <Menu isOpen={isOpen} onClose={onClose}>
      <MenuButton
        alignItems="center"
        justifyContent="center"
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w="30px"
        h="30px"
        lineHeight="100%"
        onClick={onOpen}
        borderRadius="10px"
      >
        <Icon as={MdOutlineMoreHoriz} color={iconColor} w="24px" h="24px" />
      </MenuButton>
      <MenuList w="190px" minW="unset" maxW="190px !important" border="transparent" backdropFilter="blur(63px)" bg={bgList} boxShadow={bgShadow} borderRadius="20px" p="15px">
        <MenuItem {...item} onClick={handleUpdate}>
          <Flex align="center">
            <Icon as={MdEditNote} h="16px" w="16px" me="8px" />
            <Text fontSize="sm" fontWeight="400">
              Modifier
            </Text>
          </Flex>
        </MenuItem>
        {site.cms === "wordpress" && site.actif && (
          <MenuItem {...item} onClick={() => history.push(`/admin/maintenance-wordpress?site=${site.id}`)}>
            <Flex align="center">
              <Icon as={MdBuild} h="16px" w="16px" me="8px" />
              <Text fontSize="sm" fontWeight="400">
                Voir la maintenance
              </Text>
            </Flex>
          </MenuItem>
        )}
        <MenuItem {...item} onClick={handleArchive}>
          <Flex align="center">
            <Icon as={site.actif ? MdOutlineArchive : MdOutlineUnarchive} h="16px" w="16px" me="8px" />
            <Text fontSize="sm" fontWeight="400">
              {site.actif ? "Archiver" : "Réactiver"}
            </Text>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
